import { navigate } from 'gatsby';
import * as React from 'react';
import { Spinner } from 'react-bootstrap';

import { colors } from '../../shared/colors';

import * as styles from './button.module.scss';

import { ExternalLink } from '../../assets/svg';

interface Props {
    label: string;
    block?: 'full' | 'half' | 'halfWithMargin' | 'initial';
    disabled?: boolean;
    type?: 'button' | 'reset' | 'submit' | null;
    variant?: 'primary' | 'secondary' | 'transparentTeal' | 'transparentWhite' | 'link';
    onClick?: (e) => void;
    size?: 'xs' | 'sm' | 'md' | 'lg'; // 26px | 32px | 40px | 50px;
    formId?: string;
    fullWidthOnMobile?: boolean;
    isMobile?: boolean;
    spinner?: boolean;
    showRightArrow?: boolean;
    linkHref?: string;
    linkColor?: string;
    usingMouse: boolean;
}

const Button = (props: Props) => {
    const {
        label,
        disabled,
        onClick,
        formId,
        spinner,
        isMobile,
        fullWidthOnMobile,
        linkHref,
        linkColor,
        usingMouse
    } = props;
    let { variant, type, block, size } = props;
    variant = variant ? variant : 'primary';
    type = type ? type : 'button';
    block = block ? block : 'initial';
    size = size ? size : 'md';
    const sizeClass = `btn${size}`;
    const blockClass = `btn${block}`;
    if (!label || (label.length < 1 && !spinner)) {
        // eslint-disable-next-line no-console
        console.log('--------------------------------')
        console.log(label)
        console.error('Web-Gatsby component library: Missing button label');
    }

    if (isMobile === undefined && fullWidthOnMobile) {
        // eslint-disable-next-line no-console
        console.error('Web-Gatsby component library: Missing isMobile or fullWidthOnMobile prop');
    } else {
        block = 'full';
    }

    if (variant === 'link' && !linkHref) {
        // eslint-disable-next-line no-console
        console.error('Web-Gatsby component library: Missing href for link variant');
    }

    if (variant === 'link' && linkHref) {
        return (
            <a
                href={linkHref}
                target={'_blank'}
                rel={'noreferrer'}
                className={usingMouse ? `using-mouse ${styles.link}` : styles.link}
                style={{ color: linkColor ? colors[linkColor] : colors.teal }}>
                {label} <ExternalLink aria-hidden='true' className={styles.externalIcon} />
            </a>
        );
    }
    if (variant === 'primary' && linkHref) {
        return (
            <button
                className={`button2 ${styles[`btn${variant}`]} ${styles[sizeClass]} ${
                    styles[blockClass]
                }`}
                type={'button'}
                onClick={() => {
                    navigate(linkHref);
                }}
                disabled={disabled ? true : false}>
                {label}
            </button>
        );
    }

    if (formId || type === 'submit') {
        if (!formId) {
            // eslint-disable-next-line no-console
            console.error('Web-Gatsby component library: Missing form id for button type submit');
        }
        return (
            <button
                className={`button2 ${styles[`btn${variant}`]} ${styles[sizeClass]} ${
                    styles[blockClass]
                }`}
                type='submit'
                form={formId}
                disabled={disabled ? true : false}>
                {label}
            </button>
        );
    } else if (spinner) {
        return (
            <button
                className={`button2 ${styles[`btn${variant}`]} ${styles[sizeClass]} ${
                    styles[blockClass]
                }`}
                disabled>
                <Spinner animation='border' variant='light' size='sm' className={styles.spinner} />
            </button>
        );
    } else {
        if (!onClick && !linkHref) {
            // eslint-disable-next-line no-console
            console.error('Web-Gatsby component library: Missing on click function for button');
        }
        return (
            <button
                className={`button2 ${styles[`btn${variant}`]} ${styles[sizeClass]} ${
                    styles[blockClass]
                }`}
                onClick={onClick}
                type={'button'}
                disabled={disabled ? true : false}>
                {label}
            </button>
        );
    }
};

export default Button;
